import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Pressable, Text } from "react-native";

import { GeneralWallet } from "@/components/web3/GeneralWalletConnect";
import { TronWallet } from "@/components/web3/TronWalletConnect";

export interface WidgetInformation {
  walletAddress: string;
  isTronWallet: boolean;
}

interface Props {
  setWalletAddress?: (address: string) => void;
  setWidgetInformation?: (widgetInformation: WidgetInformation) => void;
  smallVersion?: boolean;
}

export const WalletWidget = (props: Props) => {
  const [isTronWallet, setIsTronWallet] = useState(false);
  const [hasWalletConnected, setHasWalletConnected] = useState(false);

  const { t } = useTranslation();

  return (
    <View className="w-full items-center">
      {isTronWallet ? (
        <TronWallet
          clearTronWalletAddress={() => props.setWalletAddress("")}
          connectedTronWallet={(address: string) => {
            if (address) {
              props.setWalletAddress(address);
              props.setWidgetInformation({
                walletAddress: address,
                isTronWallet: true,
              });
              setHasWalletConnected(true);
            }
          }}
          disconnectTronWallet={() => {
            props.setWalletAddress("");
            setIsTronWallet(false);
            setHasWalletConnected(false);
          }}
          smallVersion={props.smallVersion}
        />
      ) : (
        <GeneralWallet
          sendWalletAddress={(address) => {
            if (address) {
              props.setWalletAddress(address);
              props.setWidgetInformation({
                walletAddress: address,
                isTronWallet: false,
              });
            }
            setHasWalletConnected(true);
          }}
        />
      )}
      {!hasWalletConnected && (
        <Pressable
          onPress={() => setIsTronWallet(!isTronWallet)}
          className="mt-2"
        >
          <Text className="text-base text-center font-light text-darkergray hover:text-black1 delay-100 transition-colors">
            {isTronWallet
              ? t("common:terms.switchtogeneral")
              : t("common:terms.switchtotron")}
          </Text>
        </Pressable>
      )}
    </View>
  );
};
